import React from 'react'
import styled from 'styled-components'
import { Col, Form, Row } from 'antd'
import { useNavigate } from 'react-router-dom'

import { FormValues, useUpdatePassword } from './useUpdatePassword'
import { InputField } from 'src/components/form'
import ButtonCustom from 'src/components/form/Button'
import LPHeader from 'src/components/layout/Header/LPHeader'
import { PATH } from 'src/pages/myPage'

const Container: React.FC = () => {
  const { form, onSubmit } = useUpdatePassword()
  const { control, handleSubmit, formState } = form
  const navigate = useNavigate()

  return (
    <Wrapper>
      <LPHeader />
      <div className="page-title">
        <h5>パスワード再設定</h5>
        <p className="mb-10">
          新しいパスワードを入力し、設定ボタンを <br />
          押してください。
        </p>
      </div>
      <StyleForm onSubmit={handleSubmit(onSubmit)}>
        <Row className="pt-20">
          <Col xs={24}>
            <label>新しいパスワード</label>
          </Col>
          <Col xs={24}>
            <InputField<FormValues>
              controller={{
                control,
                name: 'password',
              }}
              inputProps={{
                placeholder: '入力してください',
                type: 'password',
              }}
            />
          </Col>
        </Row>
        <Row className="pt-20">
          <Col xs={24}>
            <label>新しいパスワード(確認用)</label>
          </Col>
          <Col xs={24}>
            <InputField<FormValues>
              controller={{
                control,
                name: 'password_confirmation',
              }}
              inputProps={{
                placeholder: '入力してください',
                type: 'password',
              }}
            />
          </Col>
        </Row>
        <ButtonCustom
          className="btn-default mt-5 btn-submit btn-gurkha mb-30"
          loading={formState.isSubmitting}
          onClick={handleSubmit(onSubmit)}
          htmlType="submit"
          showIconRight
          name="設定する"
        />

        <ButtonCustom
          className="btn-default mt-5 btn-border-black mb-40"
          loading={false}
          onClick={() => navigate(PATH.USER_DETAIL)}
          htmlType="button"
          showIconRight
          name="キャンセル"
        />
      </StyleForm>
      {/* <Notification></Notification> */}
    </Wrapper>
  )
}

const StyleForm = styled(Form)`
  padding: 0 20px;

  & input {
    padding: 15px !important;
  }
  & .form-description {
    color: #323232;
    line-height: 24px;
    font-weight: 600;
    font-size: 13px;
  }
  & .btn-submit {
    font-size: 18px;
  }

  & label {
    font-size: 15px !important;
    font-weight: 500;
    display: block;
    margin-bottom: 10px;
  }
  & .title-box {
    padding-top: 15px;
    font-size: 13px;
    color: #323232;
    font-weight: 600;
  }
`
const Wrapper = styled.div`
  & .page-title {
    margin-top: 75px;
    text-align: center;

    & h5 {
      margin-bottom: 40px;
    }
    & p {
      line-height: 24px;
      font-weight: 500;
      font-size: 13px;
      color: var(--color-Kelp);
      margin-bottom: 70px;
    }
  }
`

export default Container
